import CustomButtonNew from 'Common/CustomButtonNew/CustomButtonNew';
import CustomDraggable from 'Common/CustomDraggable/CustomDraggable';
import ReactPortal from 'Components/ReactPortal/ReactPortal';
import React from 'react'

const InsuranceCardPicPopup = ({ onClose, disableDraggable, cardPic, picExt }) => {
    const uniqueId = "InsuranceCardPicPopup"
    return (
        <ReactPortal wrapperId={uniqueId}>
            <div
                data-te-modal-init
                className="fixed inset-0 z-10 flex items-center justify-center bg-gray-500 bg-opacity-75"
                id="exampleModalScrollable"
                tabIndex={-1}
                aria-labelledby="exampleModalScrollableLabel"
                aria-modal="true"
                data-te-open="true"
            >
                <CustomDraggable disableDraggable={disableDraggable} handle={`#${uniqueId}`}>
                    <div
                        data-te-modal-dialog-ref
                        className="relative w-full  min-[576px]:mx-auto min-[576px]:mt-2 min-[576px]:max-w-[500px] min-[992px]:max-w-[800px] min-[1200px]:max-w-[1140px] flex flex-col overflow-hidden rounded-md bg-white shadow-lg"
                    >
                        {/* Header */}
                        <div
                            id={uniqueId}
                            className="flex items-center justify-between p-5 text-2xl font-semibold border-b cursor-grab"
                        >
                            Insurance Card Pic
                            <button onClick={() => onClose(false)} className="p-1.5 shrink-0 rounded border border-slate-200 hover:border-slate-300 shadow-sm ml-2">
                                <img src="/img/crossblack.svg" alt="cross" />
                            </button>
                        </div>
                        <div className="px-5 pt-5 overflow-y-auto max-h-[70vh]">
                            <div className='grid grid-cols-12 gap-4'>
                                <div className='col-span-12'>
                                    {picExt === "pdf" ? <iframe title="InsuranceCardPicPopup" src={cardPic} style={{ width: "600px", height: "500px" }} frameborder="0" /> :
                                        <img src={cardPic} className='rounded-lg max-h-96 ' alt="patientpic" />}

                                </div>


                            </div>
                        </div>

                        {/* Footer */}
                        <div className="flex flex-wrap items-center justify-end gap-2 p-5 ">
                            <CustomButtonNew label={"Cancel"} variant={"outline"} onClick={() => onClose(false)} />
                        </div>
                    </div>
                </CustomDraggable>
            </div>
        </ReactPortal>
    )
}

export default InsuranceCardPicPopup